import {TextField} from "@mui/material";
import {useEffect, useRef, useState} from "react";

export const AdminTableNumericFilterInput = (props: any): JSX.Element => {
	const [inputValue, setInputValue] = useState<string>(props.item.value || "");
	const [isDebouncing, setIsDebouncing] = useState(false); // Track if debounce is active
	const inputRef = useRef<HTMLInputElement>(null); // Ref to track input for focus

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
		setInputValue(event.target.value);
		setIsDebouncing(true); // Start debounce on change
	};

	const handleBlur = (): void => {
		if (!isDebouncing) {
			// If not debouncing, apply value immediately on blur
			props.applyValue({...props.item, value: inputValue});
		}
	};

	useEffect(() => {
		// Set up debounce timeout for 500ms
		const debounceTimeout = setTimeout(() => {
			if (isDebouncing) {
				props.applyValue({...props.item, value: inputValue});
				setIsDebouncing(false); // Reset debounce flag
				inputRef.current?.focus(); // Reapply focus if needed
			}
		}, 500);

		// Clear timeout if component unmounts or input changes within 500ms
		return () => clearTimeout(debounceTimeout);
	}, [inputValue, isDebouncing, props]);

	return (
		<TextField
			label="Value"
			variant="standard"
			type="number"
			value={inputValue}
			onChange={handleChange}
			onBlur={handleBlur}
			inputRef={inputRef} // Assign ref to input for focus control
		/>
	);
};